import axios from 'axios';
import { APIHELPER } from '@/constants';
import { sessionHelper } from '@/utils';
import store from '@/state/store';
import qs from 'qs';

export function apiHelper(baseURL, appendAuthHeader = true, checkTokenExpired = true) {
	let userType = sessionHelper.getUserType();

	const apiInstance = axios.create({
		baseURL,
		paramsSerializer(params) {
			return qs.stringify(params, { arrayFormat: 'indices', encodeValuesOnly: true });
		},
	});

	async function checkExpired(forceRefresh = false) {
		if(checkTokenExpired == true) {
			userType = sessionHelper.getUserType();
			var tokenExpired = forceRefresh ? true : sessionHelper.isTokenExpired();
			if (tokenExpired == true) {
				var refreshTokenExpired = sessionHelper.isRefreshTokenExpired();
				if (refreshTokenExpired == true) {
					if (userType == "api")
					{
						await store.dispatch('api/auth/logout');
					}
					else if (userType == "app")
					{
						await store.dispatch('app/auth/logout');
					}
					return false;
				} else {
					try {
						if (userType == "api")
						{
							await store.dispatch('api/auth/REFRESH');
						}
						else if (userType == "app")
						{
							await store.dispatch('app/auth/REFRESH');
						}
					} catch (error) {
						if (userType == "api")
						{
							await store.dispatch('api/auth/logout');
						}
						else if (userType == "app")
						{
							await store.dispatch('app/auth/logout');
						}
						return false;
					}
				}
			}
		}

		return true;
	}

	const responseHandler = (response) => {
		return response.data;
	};

	const errorHandler = async (error) => {
		var errorMessage = "";
		var errorReturnMessage = "";
		var errorType = "";
		var errorKey = "";
		var errorResponse = error.response;
		var errorStatus = 0;
		var errorData = null;

		if (!errorResponse) {

			errorMessage = error.message;

			if (errorMessage === APIHELPER.NETWORK_ERROR) {
				errorReturnMessage = APIHELPER.NETWORK_ERROR;
			} else {
				errorReturnMessage = APIHELPER.UNKNOWN_ERROR;
			}

		} else {
			
			errorStatus = error.response.status;

			switch (errorStatus) {
				case 401:
						if(error.response.data.error)
						{
							errorReturnMessage = error.response.data.error
						}
						else
						{
							errorReturnMessage = APIHELPER.INVALID_USER;
						}

						if (checkTokenExpired == true && !error.config._retry) {
							error.config._retry = true;
							var tokenValid = await checkExpired(true);
							if (tokenValid == true) {
								var userToken = sessionHelper.getUserToken();
								error.config.headers = {
									...error.config.headers,
									Authorization: `Bearer ${userToken}`,
								};
								return apiInstance(error.config);
							}
						}
					break;

				case 400:
						errorType = typeof error.response.data.error;
						errorData = error.response.data.error;

						if (errorType === APIHELPER.OBJECT)
						{
							Object.keys(errorData).map(
								(key) => {
									if (errorKey === '') {
										errorKey = key;
									} else {
										errorKey += ',' + key;
									}
								},
							);

							errorReturnMessage = errorKey + APIHELPER.OBJECT_INVALID;
						}
						else
						{
							errorReturnMessage = errorData;
						}
					break;

				default:
					errorReturnMessage = error.response.data.error;
			}

			error.response.data.alertMessage = errorReturnMessage;
			throw error;
		}
	};

	apiInstance.interceptors.request.use(async (config) => {
		let userToken = sessionHelper.getUserToken();
		let expiredTime = sessionHelper.getUserExpiredTime();
		let refreshExpiredTime = sessionHelper.getUserRefreshExpiredTime();

		if (userToken) {
			if (!expiredTime && !refreshExpiredTime) {
				if (userType == "api")
				{
					await store.dispatch('api/auth/logout');
				}
				else if (userType == "app")
				{
					await store.dispatch('app/auth/logout');
				}
				return Promise.reject();
			}

			var tokenValid = await checkExpired();
			if (tokenValid == false) return Promise.reject();
		}

		userToken = sessionHelper.getUserToken();

		if (userToken && appendAuthHeader) {
			config.headers = {
				...config.headers,
				Authorization: `Bearer ${userToken}`,
			}
		}

		return config;
	});

	apiInstance.interceptors.response.use(
		(response) => responseHandler(response),
		(error) => errorHandler(error),
	);

	return apiInstance;
}
